import { Navigate, Outlet } from 'react-router-dom'
import { AuthSelector } from '../store/reducers/auth/auth'
import { useSelector } from 'react-redux'
import Spinner from 'react-bootstrap/Spinner'

const ProtectedRoute = () => {
	const AuthSelectors = useSelector(AuthSelector)
	if (AuthSelectors.Loading)
		return (
			<div className='spinner-container'>
				<Spinner animation='border' variant='info' />
			</div>
		)

	return (
		AuthSelectors.isAuthenticated ?
			<>
				<Outlet />
			</>
			:
			<Navigate to='/login' />

	)
}

export default ProtectedRoute